/**
 * 認證相關工具函數
 */

export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

export const checkAuth = () => {
  const token = getToken();
  return !!token;
};

export const logout = () => {
  removeToken();
  window.location.href = '/login';
};
